module.exports = __webpack_public_path__ + "static/media/for-gov.52582eb5.png";